(function (Drupal, $) {

  $(function () {

    var $mobile_menu_open_class = 'is-open';


    var $mobile_menu = $('.mobile-menu');
    var $menu_toggle_button = $('#mobile-menu-toggle-button');
    var $menu_default_text = $menu_toggle_button.html();
    var $menu_opened_text = $menu_toggle_button.attr('data-close');
    var $menu_item = $('#block-mobilemenu .menu');

    $menu_toggle_button.on('click', function () {

      if ($mobile_menu.hasClass($mobile_menu_open_class)) {
        $mobile_menu.removeClass($mobile_menu_open_class);
        $menu_toggle_button.removeClass($mobile_menu_open_class);
        $menu_toggle_button.html($menu_default_text);
        $menu_item.removeClass('show');
        $menu_item.parent().removeClass('show');
      }
      else {
        $mobile_menu.addClass($mobile_menu_open_class);
        $menu_toggle_button.addClass($mobile_menu_open_class);
        $menu_toggle_button.html($menu_opened_text);
        $menu_item.addClass('show');
        $menu_item.parent().addClass('show');
      }

    });


    // Converts the search toggle span into a button so it can be activated with a keyboard
    $.fn.changeElementType = function(newType) {
      var attrs = {};

      $.each(this[0].attributes, function(idx, attr) {
          attrs[attr.nodeName] = attr.nodeValue;
      });

      var newelement = $("<" + newType + "/>", attrs).append($(this).contents());
      this.replaceWith(newelement);
      return newelement;
    };

    if ($('span.search-toggle').length) {
      $('span.search-toggle').changeElementType('button');
    }

    $('.search-toggle').on('click', function() {
      $('.search-modal').fadeToggle().css('display', 'flex');
    });


    // This is to make the main nav keyboard accessible in IE
    $('.main-menu__item').on('focus', function() {
      var $this = $(this),
      $lastChild = $this.find('.sub-menu__item:last-child a');

      $this.addClass('active');

      $lastChild.on('focusout', function() {
        $this.removeClass('active');
      });
    });

  });


})(Drupal, jQuery);
